import { useEffect } from "preact/hooks";
import { enrollState, enrollMsg, enrollInvNr, runEnroll } from "../state/enroll.js";

/**
 * Registrierungs-Bildschirm: greift, wenn die PWA mit `?enroll=<token>` geöffnet wurde
 * (Betreiber-QR „Handy hinzufügen"). Meldet die deviceId an die Cloud und zeigt das Ergebnis.
 */
export function EnrollView() {
  useEffect(() => { void runEnroll(); }, []);
  const s = enrollState.value;
  return (
    <div class="app">
      <main class="main">
        <div class="empty">
          <h2>Gerät registrieren</h2>
          {s === "working" && <p>Registriere dieses Gerät im Inventar…</p>}
          {s === "done" && (
            <>
              <p>✓ Registriert{enrollInvNr.value !== null ? ` als Inventar-Nr. ${enrollInvNr.value}` : ""}.</p>
              <p class="muted">
                Das Gerät ist registriert{new URLSearchParams(location.search).get("venue") ? " und der Veranstaltung zugewiesen" : ""}.
                Solange die Veranstaltung läuft, ist es sofort einsatzbereit. Falls nicht, muss der
                Betreiber es im Admin freischalten („Aktivieren"), dann kann es bestellen.
              </p>
              <button
                class="btn-primary"
                onClick={() => {
                  // ?venue= aus dem QR erhalten → App bleibt auf der richtigen Veranstaltung gepinnt.
                  const v = new URLSearchParams(location.search).get("venue");
                  location.href = v ? `/?venue=${encodeURIComponent(v)}` : "/";
                }}
              >
                Weiter zur App
              </button>
            </>
          )}
          {s === "error" && (
            <>
              <p class="login-error">Registrierung fehlgeschlagen: {enrollMsg.value}</p>
              <button class="btn-primary" onClick={() => void runEnroll()}>Erneut versuchen</button>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
